// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1OCeC","label":"Labeled_label__3IpwN","divider":"Labeled_divider__2uQ3a"};